import { useEffect, lazy, Suspense } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Navigation from '@/components/portfolio/Navigation';
import Hero from '@/components/portfolio/Hero';
import HowIThink from '@/components/portfolio/HowIThink';
import Projects from '@/components/portfolio/Projects';
import Philosophy from '@/components/portfolio/Philosophy';
import Contact from '@/components/portfolio/Contact';
import SmoothScroll from '@/components/portfolio/SmoothScroll';
import { NoiseOverlay, CustomCursor } from '@/components/portfolio/Chrome';
import { ThemeProvider } from '@/components/portfolio/theme';
import ThemeToggle from '@/components/portfolio/ThemeToggle';
import CaseStudy from '@/pages/CaseStudy';
import About from '@/pages/About';
import WorkIndex from '@/pages/WorkIndex';
import Stories from '@/pages/Stories';
import Story from '@/pages/Story';
import Admin from '@/pages/Admin';
import BackToTop from '@/components/portfolio/BackToTop';
import { Seo, PERSON_SCHEMA, WEBSITE_SCHEMA } from '@/lib/seo';

const HashScroller = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            requestAnimationFrame(() => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }, [location]);
    return null;
};

const Portfolio = () => (
    <>
        <Seo jsonLd={[PERSON_SCHEMA, WEBSITE_SCHEMA]} />
        <Hero />
        <Projects />
        <HowIThink />
        <Philosophy />
        <Contact />
    </>
);

const Shell = ({ children }) => (
    <div className="App">
        <a
            href="#main-content"
            data-testid="skip-to-content"
            className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-full focus:bg-[var(--accent)] focus:text-[var(--accent-ink)] focus:font-semibold focus:text-sm focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-[var(--accent)] focus:ring-offset-2 focus:ring-offset-[var(--bg)]"
        >
            Skip to content
        </a>
        <HashScroller />
        <NoiseOverlay />
        <CustomCursor />
        <SmoothScroll />
        <Navigation />
        <ThemeToggle />
        <BackToTop />
        <main id="main-content" tabIndex={-1}>{children}</main>
    </div>
);

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Shell><Portfolio /></Shell>} />
                    <Route path="/about" element={<Shell><About /></Shell>} />
                    <Route path="/admin" element={<Shell><Admin /></Shell>} />
                    <Route path="/work" element={<Shell><WorkIndex /></Shell>} />
                    <Route path="/work/:slug" element={<Shell><CaseStudy /></Shell>} />
                    <Route path="/stories" element={<Shell><Stories /></Shell>} />
                    <Route path="/stories/:slug" element={<Shell><Story /></Shell>} />
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
